import { useEffect, useState } from "react";
import useAnalyticsEventTracker from "../../../tracker/EventTracker";
import { API, Auth, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { Card, CardSkeletonArray } from "../_components/Card";
import { SlFire } from "react-icons/sl";
import { sendGAEvent } from "../../../utils/analytics";

// prettier-ignore
const TenderQuery = `query MyQuery { 
  searchPhases(
    limit: 25, 
    sort: {field: dispatch_notice_date, direction: desc}, 
    filter: {or: [ 
      {phase: {match: "Aankondiging van een opdracht - algemene richtlijn"}},
      {phase: {match: "Concessieaankondiging"}},
      {phase: {match: "Vooraankondiging"}},
      {phase: {match: "Marktconsultatie"}}
    ]}) 
    { 
      items { 
        id 
        title 
        dispatch_notice_date 
        date_receipt 
        time_receipt 
        procedure 
        tender_id 
        description 
        tender_type 
        country 
        contracting_authority 
        phase 
        total_value 
        contacts { 
          items { 
            contact { 
              contracting_authority_id 
              contact_type 
              contractor_id 
            } 
          } 
        } 
      } 
    }
  }`;

const FavoritesQuery = (userID: string) =>
    `query MyQuery { getUser(id: "${userID}") { companies { items { company { id saved_tenders { items { tender { id } } } } } } } }`;

const NewTenders = () => {
    const [tenders, setTenders] = useState<any[]>([]);
    const [favoriteTendersIDs, setFavoriteTendersIDs] = useState<any[]>([]);
    const [companyID, setCompanyID] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        document.title = "Nieuwste 25 aanbestedingen | TenderTracer";
        EventTracker();
        handleData();
    }, []);

    async function handleData() {
        try {
            const { attributes } = await Auth.currentAuthenticatedUser({
                bypassCache: true,
            });
            
            let favoritesData: GraphQLResult<any>;
            try {
                favoritesData = (await API.graphql(
                    graphqlOperation(FavoritesQuery(attributes.sub))
                )) as GraphQLResult<any>;
            } catch (graphqlError) {
                console.error('GraphQL error in favorites query:', graphqlError);
                favoritesData = { data: { getUser: { companies: { items: [] } } } } as GraphQLResult<any>;
            }

            //Favorites
            const favoriteTenders =
                favoritesData.data?.getUser?.companies?.items[0]?.company
                    ?.saved_tenders?.items || [];

            const favoriteTenderItems: any[] = [];

            // Only process valid tender items
            favoriteTenders
                .filter((tender: any) => tender && tender.tender)
                .map((tenders: any) =>
                    favoriteTenderItems.push(tenders.tender.id)
                );

            if (favoritesData.data?.getUser?.companies?.items[0]?.company?.id) {
                setCompanyID(
                    favoritesData.data.getUser.companies.items[0].company.id
                );
            }

            setFavoriteTendersIDs(favoriteTenderItems);
            
            let tenderData: GraphQLResult<any>;
            try {
                tenderData = (await API.graphql(
                    graphqlOperation(TenderQuery)
                )) as GraphQLResult<any>;
            } catch (graphqlError) {
                console.error('GraphQL error in tenders query:', graphqlError);
                tenderData = { data: { searchPhases: { items: [] } } } as GraphQLResult<any>;
            }

            if (tenderData.data?.searchPhases?.items) {
                setTenders(tenderData.data.searchPhases.items);
                sendGAEvent('view_new_tenders', {
                    tender_count: tenderData.data.searchPhases.items.length
                });
            }

            setLoading(false);
        } catch (error) {
            console.error('Error in handleData:', error);
            setLoading(false);
            sendGAEvent('new_tenders_error', {
                error_message: error
            });
        }
    }

    function EventTracker() {
        useAnalyticsEventTracker(
            "Nieuwste 25 aanbestedingen",
            "Bekijkt Nieuwste 25 aanbestedingen",
            "Nieuwste 25 aanbestedingen"
        );
    }

    return (
        <section className="h-full w-full flex flex-col overflow-y-hidden overflow-x-hidden">
            <div className="bg-white rounded-lg border shadow ml-5 pt-2 pl-2 pr-2 mr-5 mb-2 mt-5">
                <div className="flex items-center">
                    <SlFire className="text-2xl text-primary-blue" />
                    <p className="font-bold text-lg pl-2">
                        Nieuwste 25 aanbestedingen
                    </p>
                </div>
                <p className="pb-2 pl-2 pr-2 lg:flex text-sm">
                    Hieronder zie je de nieuwste 25 aanbestedingen |
                    Marktconsultaties, aankondigingen en vooraankondigingen.
                </p>
            </div>
            <div className="flex lg:overflow-y-hidden">
                {loading ? (
                    <div className="w-full overflow-y-auto overflow-x-hidden"
                        style={{
                            height: "calc(100vh - 90px)",
                        }}
                    >
                        <CardSkeletonArray count={5} />
                    </div>
                ) : tenders.length > 0 ? (
                    <div
                        className="overflow-y-auto overflow-x-hidden"
                        style={{
                            height: "calc(100vh - 90px)",
                        }}
                    >
                        {tenders.map((item: any, index: any) => (
                            <div key={index}>
                                <Card
                                    item={item}
                                    favorite={favoriteTendersIDs.includes(
                                        item.tender_id
                                    )}
                                    companyID={companyID}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="w-full h-full flex items-center justify-center">
                        <p>Geen resultaten gevonden.</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default NewTenders;
